import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { PLUS_PLAN_PRICE } from './plusPlanPrice';

interface PlanPriceResponse {
  id: string;
  value: number;
  currency: string;
  frequency: 'annually' | 'monthly' | 'biweekly' | 'weekly';
}

interface BrowsePlanPricesResponse {
  prices: PlanPriceResponse[];
}

export interface PlusPlanPrice {
  monthly: number;
  setUpFee: number;
  currency: string;
  locale: string;
}

const PRICE_FRESH_FOR_MS = 10 * 60 * 1000;

function getPlusPlanPrices() {
  return axiosPrivate.get<BrowsePlanPricesResponse>('/v3/pharmacist/plans/plus/prices');
}

// The Plans API returns lowercase ISO codes ('gbp'); PLUS_PLAN_PRICE.currency is uppercase.
function isPlusPlanCurrency(currency: string): boolean {
  return currency.toLowerCase() === PLUS_PLAN_PRICE.currency.toLowerCase();
}

function selectMonthlyPrice(response: { data: BrowsePlanPricesResponse }): number | undefined {
  return response.data.prices.find(
    (price) => price.frequency === 'monthly' && isPlusPlanCurrency(price.currency)
  )?.value;
}

export default function usePlusPlanPrice(): PlusPlanPrice {
  const { data: monthly } = useQuery({
    queryKey: ['plan-prices', 'plus'],
    queryFn: getPlusPlanPrices,
    select: selectMonthlyPrice,
    staleTime: PRICE_FRESH_FOR_MS,
  });

  return { ...PLUS_PLAN_PRICE, monthly: monthly ?? PLUS_PLAN_PRICE.monthly };
}
